function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null);

var _ref3 =
/*#__PURE__*/
React.createElement("polygon", {
  className: "color",
  points: "100.0,9.158793248902555 153.39512162874652,26.507919948833973 186.39512162874652,71.92852332438268 186.39512162874652,128.0714766756173 153.39512162874652,173.49208005116606 100.0,190.84120675109745 46.604878371253484,173.49208005116603 13.604878371253477,128.07147667561733 13.604878371253477,71.92852332438268 46.604878371253484,26.50791994883396",
  stroke: "black"
});

var _ref4 =
/*#__PURE__*/
React.createElement("polygon", {
  fill: "black",
  fillOpacity: 0,
  points: "133.0,145.42060337554872 67.0,145.42060337554872 46.604878371253484,82.6508733000686 100.0,43.85704664876537 153.39512162874652,82.6508733000686",
  stroke: "black"
});

var _ref5 =
/*#__PURE__*/
React.createElement("polygon", {
  fill: "black",
  fillOpacity: 0.2,
  points: "100.0,43.85704664876537 100.0,9.158793248902555 153.39512162874652,26.507919948833973 186.39512162874652,71.92852332438268 153.39512162874652,82.6508733000686",
  stroke: "black"
});

var _ref6 =
/*#__PURE__*/
React.createElement("polygon", {
  fill: "black",
  fillOpacity: 0.2,
  points: "153.39512162874652,82.6508733000686 186.39512162874652,71.92852332438268 186.39512162874652,128.0714766756173 153.39512162874652,173.49208005116606 133.0,145.42060337554872",
  stroke: "black"
});

var _ref7 =
/*#__PURE__*/
React.createElement("polygon", {
  fill: "black",
  fillOpacity: 0.2,
  points: "133.0,145.42060337554872 153.39512162874652,173.49208005116606 100.0,190.84120675109745 46.604878371253484,173.49208005116603 67.0,145.42060337554872",
  stroke: "black"
});

var _ref8 =
/*#__PURE__*/
React.createElement("polygon", {
  fill: "black",
  fillOpacity: 0.2,
  points: "67.0,145.42060337554872 46.604878371253484,173.49208005116603 13.604878371253477,128.07147667561733 13.604878371253477,71.92852332438268 46.604878371253484,82.6508733000686",
  stroke: "black"
});

var _ref9 =
/*#__PURE__*/
React.createElement("polygon", {
  fill: "black",
  fillOpacity: 0.2,
  points: "46.604878371253484,82.6508733000686 13.604878371253477,71.92852332438268 46.604878371253484,26.50791994883396 100.0,9.158793248902555 100.0,43.85704664876537",
  stroke: "black"
});

var SvgD12 = function SvgD12(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    baseProfile: "full",
    height: "200px",
    viewBox: "0 0 200 200",
    width: "200px",
    xmlnsev: "http://www.w3.org/2001/xml-events",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgD12, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/d12.dbeca6b8.svg";
export { ForwardRef as ReactComponent };